module.exports = __webpack_public_path__ + "static/img/MITCHELL_STARC.b6f3974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCHELL_STARC.jpg
// module id = /3I9
// module chunks = 0